import { createSelector, } from 'reselect';
import { propOr, } from 'ramda';

const selectGame = propOr({}, 'game');
export const gameResultsSelector = createSelector(
  selectGame,
  propOr({}, 'gameResults')
);
